module.exports = __webpack_public_path__ + "static/img/Roosters.00f25c1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Roosters.svg
// module id = PwdN
// module chunks = 1